export const LEGAL_LINKS = Object.freeze({
  TERMS_OF_SERVICE: 'https://www.mobileaction.co/terms-of-service/',
  PRIVACY_POLICY: 'https://www.mobileaction.co/privacy-policy/',
})

export const PAYMENT_PERIODS = Object.freeze({
  FREE: 'FREE',
  MONTHLY: 'MONTHLY',
  YEARLY: 'YEARLY',
})

export const INTENT_TYPE = Object.freeze({
  PAYMENT: 'PAYMENT',
  SETUP: 'SETUP',
})

export const PAYMENT_STATE = Object.freeze({
  PENDING: 'PENDING',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
})

export const PLAN_TYPE = Object.freeze({
  TRIAL: 'TRIAL',
  PAID: 'PAID',
  ADD_ON: 'ADD_ON',
  FREE: 'FREE',
})

export const STATUS = Object.freeze({
  IDLE: 'idle',
  LOADING: 'loading',
  SETUP_WAITING: 'setup_waiting',
  SUBSCRIPTION_WAITING: 'subscription_waiting',
  ERROR: 'error',
  SUCCESS: 'success',
})

export const SUBSCRIPTION_ACTION_STATES = Object.freeze({
  UPGRADE: 'UPGRADE',
  DOWNGRADE: 'DOWNGRADE',
  GET_IN_TOUCH: 'GET_IN_TOUCH',
  BOOK_A_DEMO: 'BOOK_A_DEMO',
  YEARLY_SWITCH: 'YEARLY_SWITCH',
  MONTHLY_SWITCH: 'MONTHLY_SWITCH',
  CURRENT_PLAN: 'CURRENT_PLAN',
  GET_STARTED: 'GET_STARTED',
  START_FREE_TRIAL: 'START_FREE_TRIAL',
  START_FREE_TRIAL_ONBOARDING: 'START_FREE_TRIAL_ONBOARDING',
  PENDING_DOWNGRADE: 'PENDING_DOWNGRADE',
})
